<template>
  <div class="flex h-full">
    <el-tabs v-model="activeName" tab-position="left" class="w-152px h-130px ">
      <el-tab-pane label="入厂三级培训" name="incomingThreeTraining"> </el-tab-pane>
      <el-tab-pane label="其它安全培训" name="otherSecurityTraining"> </el-tab-pane>
      <el-tab-pane label="现场处置方案" name="situationSolution"> </el-tab-pane>
    </el-tabs>
    <div class="ml-10px flex-1 h-full">
      <IncomingThreeTraining v-if="activeName === 'incomingThreeTraining'" :orgId="orgId" />
      <OtherSecurityTraining
        v-if="activeName === 'otherSecurityTraining'"
        :contractorId="contractorId"
      />
      <SituationSolution v-if="activeName === 'situationSolution'" :contractorId="contractorId" />
    </div>
  </div>
</template>
<script>
import IncomingThreeTraining from './incomingThreeTraining'
import OtherSecurityTraining from './otherSecurityTraining'
import SituationSolution from './situationSolution'

export default {
  components: {
    IncomingThreeTraining,
    OtherSecurityTraining,
    SituationSolution,
  },
  props: {
    orgId: {
      type: String,
      default: '',
    },
    contractorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeName: 'incomingThreeTraining',
    }
  },
}
</script>
